/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Mitarbeiter API
 * Employee master data: contact details, organisation, keys, parking and vehicles.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AuditEntry,
  Employee,
  EmployeeDetail,
  EmployeeInput,
  ListEmployeesParams
} from '../models';

import { customFetch } from '../../fetcher.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListEmployeesUrl = (params?: ListEmployeesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/employees?${stringifiedParams}` : `/api/employees`
}

export const listEmployees = async (params?: ListEmployeesParams, options?: Parameters<typeof customFetch>[1]): Promise<Employee[]> => {

  return customFetch<Employee[]>(getListEmployeesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEmployeesQueryKey = (params?: ListEmployeesParams,) => {
    return [
    `/api/employees`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEmployeesQueryOptions = <TData = Awaited<ReturnType<typeof listEmployees>>, TError = unknown>(params?: ListEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmployees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEmployeesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmployees>>> = ({ signal }) => listEmployees(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEmployees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEmployeesQueryResult = NonNullable<Awaited<ReturnType<typeof listEmployees>>>
export type ListEmployeesQueryError = unknown


export function useListEmployees<TData = Awaited<ReturnType<typeof listEmployees>>, TError = unknown>(
 params: undefined |  ListEmployeesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmployees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEmployees>>,
          TError,
          Awaited<ReturnType<typeof listEmployees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEmployees<TData = Awaited<ReturnType<typeof listEmployees>>, TError = unknown>(
 params?: ListEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmployees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEmployees>>,
          TError,
          Awaited<ReturnType<typeof listEmployees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEmployees<TData = Awaited<ReturnType<typeof listEmployees>>, TError = unknown>(
 params?: ListEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmployees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListEmployees<TData = Awaited<ReturnType<typeof listEmployees>>, TError = unknown>(
 params?: ListEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmployees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEmployeesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateEmployeeUrl = () => {




  return `/api/employees`
}

export const createEmployee = async (employeeInput: EmployeeInput, options?: Parameters<typeof customFetch>[1]): Promise<Employee> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Employee>(getCreateEmployeeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(employeeInput)
  }
);}





export const getCreateEmployeeMutationKey = () => ['createEmployee'] as const;

export const getCreateEmployeeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployee>>, TError,CreateEmployeeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createEmployee>>, TError,CreateEmployeeMutationVariables, TContext> => {

const mutationKey = getCreateEmployeeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmployee>>, CreateEmployeeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createEmployee(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEmployeeMutationResult = NonNullable<Awaited<ReturnType<typeof createEmployee>>>
    export type CreateEmployeeMutationBody = EmployeeInput
    export type CreateEmployeeMutationError = unknown
    export type CreateEmployeeMutationVariables = {data: EmployeeInput}

    export const useCreateEmployee = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployee>>, TError,CreateEmployeeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createEmployee>>,
        TError,
        CreateEmployeeMutationVariables,
        TContext
      > => {
      return useMutation(getCreateEmployeeMutationOptions(options), queryClient);
    }
    export const getGetEmployeeUrl = (id: number,) => {




  return `/api/employees/${id}`
}

export const getEmployee = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<EmployeeDetail> => {

  return customFetch<EmployeeDetail>(getGetEmployeeUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEmployeeQueryKey = (id: number,) => {
    return [
    `/api/employees/${id}`
    ] as const;
    }


export const getGetEmployeeQueryOptions = <TData = Awaited<ReturnType<typeof getEmployee>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployee>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployee>>> = ({ signal }) => getEmployee(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployee>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployee>>>
export type GetEmployeeQueryError = unknown


export function useGetEmployee<TData = Awaited<ReturnType<typeof getEmployee>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployee>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployee>>,
          TError,
          Awaited<ReturnType<typeof getEmployee>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployee<TData = Awaited<ReturnType<typeof getEmployee>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployee>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployee>>,
          TError,
          Awaited<ReturnType<typeof getEmployee>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployee<TData = Awaited<ReturnType<typeof getEmployee>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployee>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEmployee<TData = Awaited<ReturnType<typeof getEmployee>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployee>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateEmployeeUrl = (id: number,) => {




  return `/api/employees/${id}`
}

export const updateEmployee = async (id: number,
    employeeInput: EmployeeInput, options?: Parameters<typeof customFetch>[1]): Promise<Employee> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Employee>(getUpdateEmployeeUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(employeeInput)
  }
);}





export const getUpdateEmployeeMutationKey = () => ['updateEmployee'] as const;

export const getUpdateEmployeeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployee>>, TError,UpdateEmployeeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployee>>, TError,UpdateEmployeeMutationVariables, TContext> => {

const mutationKey = getUpdateEmployeeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployee>>, UpdateEmployeeMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateEmployee(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployeeMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployee>>>
    export type UpdateEmployeeMutationBody = EmployeeInput
    export type UpdateEmployeeMutationError = unknown
    export type UpdateEmployeeMutationVariables = {id: number;data: EmployeeInput}

    export const useUpdateEmployee = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployee>>, TError,UpdateEmployeeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployee>>,
        TError,
        UpdateEmployeeMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateEmployeeMutationOptions(options), queryClient);
    }
    export const getDeleteEmployeeUrl = (id: number,) => {




  return `/api/employees/${id}`
}

/**
 * @summary Deletes the record for good. Usually you want status "left" instead, which keeps the history.
Refused while keys or parking spots are still assigned; vehicles are deleted with the employee.
 */
export const deleteEmployee = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteEmployeeUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteEmployeeMutationKey = () => ['deleteEmployee'] as const;

export const getDeleteEmployeeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployee>>, TError,DeleteEmployeeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmployee>>, TError,DeleteEmployeeMutationVariables, TContext> => {

const mutationKey = getDeleteEmployeeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmployee>>, DeleteEmployeeMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteEmployee(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmployeeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmployee>>>

    export type DeleteEmployeeMutationError = void
    export type DeleteEmployeeMutationVariables = {id: number}

    /**
 * @summary Deletes the record for good. Usually you want status "left" instead, which keeps the history.
Refused while keys or parking spots are still assigned; vehicles are deleted with the employee.
 */
export const useDeleteEmployee = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployee>>, TError,DeleteEmployeeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEmployee>>,
        TError,
        DeleteEmployeeMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteEmployeeMutationOptions(options), queryClient);
    }
    export const getEmployeeHistoryUrl = (id: number,) => {




  return `/api/employees/${id}/history`
}

/**
 * @summary Everything that changed about this employee, including their keys, parking spots and vehicles. Newest first.
 */
export const employeeHistory = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<AuditEntry[]> => {

  return customFetch<AuditEntry[]>(getEmployeeHistoryUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getEmployeeHistoryQueryKey = (id: number,) => {
    return [
    `/api/employees/${id}/history`
    ] as const;
    }


export const getEmployeeHistoryQueryOptions = <TData = Awaited<ReturnType<typeof employeeHistory>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeeHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEmployeeHistoryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof employeeHistory>>> = ({ signal }) => employeeHistory(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof employeeHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EmployeeHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof employeeHistory>>>
export type EmployeeHistoryQueryError = unknown


export function useEmployeeHistory<TData = Awaited<ReturnType<typeof employeeHistory>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeeHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof employeeHistory>>,
          TError,
          Awaited<ReturnType<typeof employeeHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEmployeeHistory<TData = Awaited<ReturnType<typeof employeeHistory>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeeHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof employeeHistory>>,
          TError,
          Awaited<ReturnType<typeof employeeHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEmployeeHistory<TData = Awaited<ReturnType<typeof employeeHistory>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeeHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Everything that changed about this employee, including their keys, parking spots and vehicles. Newest first.
 */

export function useEmployeeHistory<TData = Awaited<ReturnType<typeof employeeHistory>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeeHistory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEmployeeHistoryQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPhotoUrl = (id: number,) => {




  return `/api/employees/${id}/photo`
}

/**
 * @summary The photo as JPEG or PNG.
 */
export const getPhoto = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<Blob> => {

  return customFetch<Blob>(getGetPhotoUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPhotoQueryKey = (id: number,) => {
    return [
    `/api/employees/${id}/photo`
    ] as const;
    }


export const getGetPhotoQueryOptions = <TData = Awaited<ReturnType<typeof getPhoto>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPhoto>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPhotoQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPhoto>>> = ({ signal }) => getPhoto(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPhoto>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPhotoQueryResult = NonNullable<Awaited<ReturnType<typeof getPhoto>>>
export type GetPhotoQueryError = void


export function useGetPhoto<TData = Awaited<ReturnType<typeof getPhoto>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPhoto>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhoto>>,
          TError,
          Awaited<ReturnType<typeof getPhoto>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPhoto<TData = Awaited<ReturnType<typeof getPhoto>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPhoto>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhoto>>,
          TError,
          Awaited<ReturnType<typeof getPhoto>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPhoto<TData = Awaited<ReturnType<typeof getPhoto>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPhoto>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The photo as JPEG or PNG.
 */

export function useGetPhoto<TData = Awaited<ReturnType<typeof getPhoto>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPhoto>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPhotoQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPutPhotoUrl = (id: number,) => {




  return `/api/employees/${id}/photo`
}

/**
 * @summary Replaces the photo. The body is the image itself (JPEG or PNG, at most 2 MB).
 */
export const putPhoto = async (id: number,
    putPhotoBody: Blob, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<void>(getPutPhotoUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'image/jpeg', ...getHeaders(options?.headers) },
    body: putPhotoBody
  }
);}





export const getPutPhotoMutationKey = () => ['putPhoto'] as const;

export const getPutPhotoMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPhoto>>, TError,PutPhotoMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putPhoto>>, TError,PutPhotoMutationVariables, TContext> => {

const mutationKey = getPutPhotoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPhoto>>, PutPhotoMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  putPhoto(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof putPhoto>>>
    export type PutPhotoMutationBody = Blob
    export type PutPhotoMutationError = void
    export type PutPhotoMutationVariables = {id: number;data: Blob}

    /**
 * @summary Replaces the photo. The body is the image itself (JPEG or PNG, at most 2 MB).
 */
export const usePutPhoto = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPhoto>>, TError,PutPhotoMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPhoto>>,
        TError,
        PutPhotoMutationVariables,
        TContext
      > => {
      return useMutation(getPutPhotoMutationOptions(options), queryClient);
    }
    export const getDeletePhotoUrl = (id: number,) => {




  return `/api/employees/${id}/photo`
}

export const deletePhoto = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeletePhotoUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeletePhotoMutationKey = () => ['deletePhoto'] as const;

export const getDeletePhotoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePhoto>>, TError,DeletePhotoMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePhoto>>, TError,DeletePhotoMutationVariables, TContext> => {

const mutationKey = getDeletePhotoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePhoto>>, DeletePhotoMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deletePhoto(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePhotoMutationResult = NonNullable<Awaited<ReturnType<typeof deletePhoto>>>

    export type DeletePhotoMutationError = unknown
    export type DeletePhotoMutationVariables = {id: number}

    export const useDeletePhoto = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePhoto>>, TError,DeletePhotoMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePhoto>>,
        TError,
        DeletePhotoMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePhotoMutationOptions(options), queryClient);
    }
    export const getEmployeeVcardUrl = (id: number,) => {




  return `/api/employees/${id}/vcard`
}

/**
 * @summary One employee's contact card (vCard 3.0, with photo).
 */
export const employeeVcard = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<string> => {

  return customFetch<string>(getEmployeeVcardUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getEmployeeVcardQueryKey = (id: number,) => {
    return [
    `/api/employees/${id}/vcard`
    ] as const;
    }


export const getEmployeeVcardQueryOptions = <TData = Awaited<ReturnType<typeof employeeVcard>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeeVcard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEmployeeVcardQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof employeeVcard>>> = ({ signal }) => employeeVcard(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof employeeVcard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EmployeeVcardQueryResult = NonNullable<Awaited<ReturnType<typeof employeeVcard>>>
export type EmployeeVcardQueryError = unknown


export function useEmployeeVcard<TData = Awaited<ReturnType<typeof employeeVcard>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeeVcard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof employeeVcard>>,
          TError,
          Awaited<ReturnType<typeof employeeVcard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEmployeeVcard<TData = Awaited<ReturnType<typeof employeeVcard>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeeVcard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof employeeVcard>>,
          TError,
          Awaited<ReturnType<typeof employeeVcard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEmployeeVcard<TData = Awaited<ReturnType<typeof employeeVcard>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeeVcard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One employee's contact card (vCard 3.0, with photo).
 */

export function useEmployeeVcard<TData = Awaited<ReturnType<typeof employeeVcard>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeeVcard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEmployeeVcardQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAllVcardsUrl = () => {




  return `/api/vcards`
}

/**
 * @summary All current employees (status "active"; hidden ones only for admins) as one vCard file with photos, for importing into an e-mail
client or phone. Thunderbird, Apple Contacts, Google Contacts, Outlook on the web and the new Outlook
import every card in it; classic Outlook for Windows only takes the first one when the file is opened.
 */
export const allVcards = async ( options?: Parameters<typeof customFetch>[1]): Promise<string> => {

  return customFetch<string>(getAllVcardsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAllVcardsQueryKey = () => {
    return [
    `/api/vcards`
    ] as const;
    }


export const getAllVcardsQueryOptions = <TData = Awaited<ReturnType<typeof allVcards>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allVcards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllVcardsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof allVcards>>> = ({ signal }) => allVcards({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof allVcards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AllVcardsQueryResult = NonNullable<Awaited<ReturnType<typeof allVcards>>>
export type AllVcardsQueryError = unknown


export function useAllVcards<TData = Awaited<ReturnType<typeof allVcards>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof allVcards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof allVcards>>,
          TError,
          Awaited<ReturnType<typeof allVcards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllVcards<TData = Awaited<ReturnType<typeof allVcards>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allVcards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof allVcards>>,
          TError,
          Awaited<ReturnType<typeof allVcards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAllVcards<TData = Awaited<ReturnType<typeof allVcards>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allVcards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary All current employees (status "active"; hidden ones only for admins) as one vCard file with photos, for importing into an e-mail
client or phone. Thunderbird, Apple Contacts, Google Contacts, Outlook on the web and the new Outlook
import every card in it; classic Outlook for Windows only takes the first one when the file is opened.
 */

export function useAllVcards<TData = Awaited<ReturnType<typeof allVcards>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allVcards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAllVcardsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






